import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { MenuItemsModel } from '@core/menu/menu.model';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';

const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Parameters,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Parameters,
        title: marker('modules.parameters.head'),
        loadChildren: () => import('./features/parameters/parameters.routes').then((r) => r.routes),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Appearance,
        title: marker('modules.appearance.head'),
        loadChildren: () => import('./features/appearance/appearance.routes').then((r) => r.routes),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
